import { API_KEY, API_URL_WITHOUT_USER } from "../../Utils/API";
import {
  getDispatch,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../Utils/helper";
import { HttpUtil } from "../../Utils/http-utils";
import {
  ADVANCE_PAYOUT_DETAIL,
  GET_ADVANCE_PAYMENT_ACTION,
  GET_DETAIL_TYPE,
  GET_FINANCE_QC,
  GET_HISTORY,
  GET_INSURER_TEST_PACKAGE_DETAIL,
  GET_PAYABLE_ACTION,
  GET_PAYOUT_COUNT_NETWORK,
  GET_PAYOUT_DETAILS_LIST,
  GET_PAYOUT_STATUS,
  GET_QC_APPROVAL_APPOINTMENT,
  GET_TOTAL_APPOINTMENT_PAYOUT,
  GET_TOTAL_COUNT,
  GET_TOTAL_PROVIDERS_PAYOUT,
  getNetworkMenuId,
  getRole,
  getToken,
  HISTORY_COUNT_ROW,
  GET_INFORMATION_ACCESS,
  GET_TOTAL_CLOSED_APPOINTMENT,
} from "../../Utils/types";

export const getPayoutCountsNetworkAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetPayoutCountsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    getDispatch(GET_PAYOUT_COUNT_NETWORK, res?.data?.results[0], dispatch);
  });
};
export const GetPayoutStatus = (params1, params2) => (dispatch) => {
  console.log(params1, params2)
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetPayoutStatus?isPayout=${params2}&isBilling=${params1}`;
  return HttpUtil.makeGET(url,{}, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    // MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    getDispatch(
      GET_PAYOUT_STATUS,
      res?.data?.results?.lstRequestStatus,
      dispatch
    );
  });
};

export const getPayoutDetailsNetworkAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetPayoutDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    getDispatch(GET_PAYOUT_DETAILS_LIST, res?.data?.results, dispatch);
  });
};

export const getProviderPayoutDetailsNetworkAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetProviderPayoutDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
    getDispatch(
      GET_TOTAL_PROVIDERS_PAYOUT,
      res?.data?.results?.lstProviderPayoutDetails,
      dispatch
    );
  });
};

export const GetAppointmentPayoutDetailsNetworkAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetAppointmentPayoutDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    console.log("first", res);
    isLoadingAction(false, dispatch);
    getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
    getDispatch(
      GET_TOTAL_APPOINTMENT_PAYOUT,
      res?.data?.results?.lstAppointmentPayoutDetails,
      dispatch
    );
  });
};
export const GetInvoiceDetailsNetwork = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetInvoiceDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    console.log("GetInvoiceDetailsNetwork res", res);
    isLoadingAction(false, dispatch);
    getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
    getDispatch(
      GET_TOTAL_APPOINTMENT_PAYOUT,
      res?.data?.results?.lstInvoiceDetails,
      dispatch
    );
  });
};

export const GetQCApprovalDetailsNetworkAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetAppointmentPayoutQCApprovalDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
    getDispatch(
      GET_QC_APPROVAL_APPOINTMENT,
      res?.data?.results?._lstAppointmentQCDetails,
      dispatch
    );
  });
};
export const GetAppointmentInsurerAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetAppointmentInsurerQCApprovalDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
    getDispatch(
      GET_QC_APPROVAL_APPOINTMENT,
      res?.data?.results?._lstAppointmentQCDetails,
      dispatch
    );
  });
};
export const PayoutEditByFinance = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/PayoutEditByFinance`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    return res;
  });
};

export const GeneratePayoutAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GeneratePayout`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  });
};

export const GetFinanceQcAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetProviderPayoutQCApprovalDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
    getDispatch(GET_FINANCE_QC, res?.data?.results?.lstDetails, dispatch);
  });
};
export const GetInsurerBillingClientAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetInsurerBillingQCApprovalDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
    getDispatch(GET_FINANCE_QC, res?.data?.results?.lstDetails, dispatch);
  });
};
export const GetPayableAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetGeneratedPayIdDetailsNetwork`;
  
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
    getDispatch(
      GET_PAYABLE_ACTION,
      res?.data?.results?.lstPayIdDetails,
      dispatch
    );
  });
};
export const GetAdvancePayoutDetails = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetAdvancePayoutDetails`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
    getDispatch(
      ADVANCE_PAYOUT_DETAIL,
      res?.data?.results?.lstAdvancePayoutDetails,
      dispatch
    );
  });
};
export const PayoutUploadDocuments = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/PayoutUploadDocuments`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    getSnackbarSuccess("success", res.data.message, dispatch);
  });
};
export const DeleteUploadPayoutDocuments = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/DeleteUploadPayoutDocuments`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    getSnackbarSuccess("success", res.data.message, dispatch);
  });
};
export const GetInsurerTestDetail = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetInsurerTestPackageRateDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    getDispatch(GET_INSURER_TEST_PACKAGE_DETAIL, res?.data?.results, dispatch);
  });
};
export const GetInsurerHomeVisitAmount = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetInsurerHomeVisitAmount`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  });
  // .then((res) => {
  //     isLoadingAction(false, dispatch);
  //     console.log(res)
  //     return res
  //     // console.log(res)
  //     // getDispatch(GET_INSURER_TEST_PACKAGE_DETAIL,res?.data?.results,dispatch)
  // });
};
export const GenerateUTRAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GenerateUTR`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  });
};

export const AddPayoutApprovalAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/AddPayoutApproval`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  });
};

export const AddUpdatePayableAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/AddUpdatePayable`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  });
};
export const AddUpdateInsurerPayableAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/AddUpdateInsurerPayable`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  });
};
export const ExportToExcelPayoutDetailsNetwork = (e) => (dispatch) => {
  // isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/ExportToExcelPayoutDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  });
};
export const GetAdvanceAmountCaseNoDetailNetworkAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetAdvanceAmountCaseNoDetailNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  });
};
export const AddUpdateAdvancePayoutAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/AddUpdateAdvancePayout`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  });
};
export const AddUpdateInsurerAdvancePayout = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/AddUpdateInsurerAdvancePayout`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  });
};
export const RevertPayoutInsurerApprovalIBU = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/RevertPayoutInsurerApprovalIBU`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    return res;
  });
};
export const PayoutInvoiceGenerationBulkUpload = (e,searchFilter) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/PayoutInvoiceGenerationBulkUpload?month=${searchFilter?.month}&year=${searchFilter?.year}&ChainId=${searchFilter?.chainId}&ProviderId=${searchFilter?.providerId}&InvoiceNo=${searchFilter?.invoiceNo}&InvoiceDate=${searchFilter?.invoiceDate}`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    return res;
  });
};

export const GetAdvancePaymentFlow = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetAdvancePaymentFlowNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
    getDispatch(GET_INFORMATION_ACCESS, res?.data?.results?.lstInformationDetails, dispatch);
    getDispatch(
      GET_ADVANCE_PAYMENT_ACTION,
      res?.data?.results?.lstAdvPaymentDetails,
      dispatch
    );
  });
};
export const AdvancePaymenViewHistory = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetAdvancePaymentHistory`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    console.log("GET_HISTORY res",res)
    getDispatch(HISTORY_COUNT_ROW, res?.data?.results?.totalRow, dispatch);
    getDispatch(
      GET_HISTORY,
      res?.data?.results?.lstAdvPaymentDetails,
      dispatch
    );
  });
};
export const AddUpdateAdvancePaymentFlowNetwork = (e) => (dispatch) => {
  //
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/AddUpdateAdvancePaymentFlowFinanceNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    // getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
    // getDispatch(
    //   GET_ADVANCE_PAYMENT_ACTION,
    //   res?.data?.results?.lstAdvPaymentDetails,
    //   dispatch
    // );
    return res;
  });

};
export const GetInsurerSysChargeOrAdvAmount = (e) => (dispatch) => {
  //
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetInsurerSysChargeOrAdvAmount`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    getDispatch(GET_INSURER_TEST_PACKAGE_DETAIL, res?.data?.results, dispatch);
    
    return res;
  });

};
export const GetAdvancePaymentFlowCaseNo = (e) => (dispatch) => {
  //
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetAdvancePaymentFlowCaseNo`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    
    return res;
  });

};
export const EverGreenPOSTApi = (e,api_path) => (dispatch) => {
  //
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/${api_path}`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    
    return res;
  });

};
export const deleteAdvancePaymentFiles = (e) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/DeleteAdvancePaymentFiles`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getSnackbarSuccess("success", "Report deleted successfully", dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  });
};

export const GetTotalCloseAppointmentDetailsNetwork = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetTotalCloseAppointmentDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    console.log("first ressss", res);
    isLoadingAction(false, dispatch);
    getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
    getDispatch(
      GET_TOTAL_CLOSED_APPOINTMENT,
      res?.data?.results?.lstAppointmentPayoutDetails,
      dispatch
    );
    
  });
};
export const ExportToExcelTotalClosedApptDetailsNetwork = (e) => (dispatch) => {
  // isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/ExportToExcelTotalClosedApptDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  });
};

export const CancelOrRejectAdvancePaymentFlow = (e) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/CancelOrRejectAdvancePaymentFlow`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getSnackbarSuccess("success", res?.data?.message, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  });
};

export const PayoutAdjustmentAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/PayoutAdjustment`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    return res
  });
};
export const PayoutDicountEditByFinance = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/PayoutDicountEditByFinance`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    return res;
  });
};

